import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LocationsListOtherDetails } from "./masters";

const emptyOtherDetailsRow = { location: "" };

const handleKeyPress = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
  }
};

/**
 * Owns other-details state so stock/location edits do not re-render stone rows
 * in the parent ProductAdvanced page.
 */
const ProductAdvancedOtherDetails = ({
  call,
  initialOtherDetails,
  valuesRef,
}) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [formValues_otherDetails, setFormValues_otherDetails] = useState([
    emptyOtherDetailsRow,
  ]);
  const otherDetailsLocationRef = useRef("");
  const setOtherDetailsLocationNoRerender = useCallback((value) => {
    otherDetailsLocationRef.current = value;
    setFormValues_otherDetails((prev) => [...prev]);
  }, []);

  useEffect(() => {
    if (initialOtherDetails) {
      setFormValues_otherDetails(
        initialOtherDetails.length
          ? initialOtherDetails
          : [emptyOtherDetailsRow]
      );
    }
  }, [initialOtherDetails]);

  useEffect(() => {
    if (valuesRef) {
      valuesRef.current = formValues_otherDetails;
    }
  }, [formValues_otherDetails, valuesRef]);

  const otherDetailsLocationsKey = formValues_otherDetails
    .map((e) => e.location || "")
    .join(",");

  const map_otherDetails = (index, key, value) => {
    setFormValues_otherDetails((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [key]: parseInt(value) };
      return next;
    });
  };

  const addFormFields_otherDetails = () => {
    setFormValues_otherDetails((prev) => [
      ...prev,
      { ...emptyOtherDetailsRow },
    ]);
  };

  const removeFormFields_otherDetails = (i) => {
    setFormValues_otherDetails((prev) => {
      const next = [...prev];
      next.splice(i, 1);
      return next;
    });
  };

  return (
    <div className="row  mb-5">
      <h4 className="pro-sub-heading">{t("other details")} *</h4>
      <div className="col-md-12">
        <table className="com-product-table">
          <thead>
            <tr>
              <th>{t("Location")}</th>
              <th>{t("Current Stock")}</th>
              <th>{t("Available Stock")}</th>
              <th>{t("Reorder Point")}</th>
              <th>{t("Reorder Quantity")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <>
              {call
                ? formValues_otherDetails.map((element, index) => (
                    <tr key={index}>
                      <td>
                        <LocationsListOtherDetails
                          setOtherDetailsLocation={
                            setOtherDetailsLocationNoRerender
                          }
                          setstatusSelectedOptions={formValues_otherDetails}
                          index_stone={index}
                          selected_id={element.location}
                          excludeLocationIds={otherDetailsLocationsKey}
                        />
                      </td>

                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            onChange={(e) =>
                              map_otherDetails(
                                index,
                                "currentstock",
                                e.target.value ? e.target.value : 0
                              )
                            }
                            className="h-100"
                            value={
                              element?.currentstock
                                ? parseInt(element.currentstock)
                                : 0
                            }
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            onChange={(e) =>
                              map_otherDetails(
                                index,
                                "availablestock",
                                e.target.value ? e.target.value : 0
                              )
                            }
                            className="h-100"
                            value={
                              element?.availablestock
                                ? parseInt(element.availablestock)
                                : 0
                            }
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            value={
                              element?.reorderpoint
                                ? parseInt(element.reorderpoint)
                                : 0
                            }
                            onChange={(e) =>
                              map_otherDetails(
                                index,
                                "reorderpoint",
                                e.target.value
                              )
                            }
                            className="h-100"
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            value={
                              element?.reorderquantity
                                ? parseInt(element.reorderquantity)
                                : 0
                            }
                            onChange={(e) =>
                              map_otherDetails(
                                index,
                                "reorderquantity",
                                e.target.value
                              )
                            }
                            className="h-100"
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>

                      <td>
                        {!index ? (
                          <button
                            type="button"
                            onClick={addFormFields_otherDetails}
                            className="row-btn ct-disable-btn"
                          >
                            <img
                              src={
                                base_assets + "images/icons/add-detail.png"
                              }
                              alt=""
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() =>
                              removeFormFields_otherDetails(index)
                            }
                            className="row-btn ct-disable-btn"
                          >
                            <img
                              src={
                                base_assets + "images/icons/minus-detail.png"
                              }
                              alt=""
                            />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                : ""}
            </>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default memo(ProductAdvancedOtherDetails);
